// import React, { useEffect, useState, useMemo } from "react";
// import {
//   getAllPMs,
//   getPendingPMs,
//   approvePM,
//   updatePM,
//   deletePM,
//   createPM
// } from "../../../services/PmService";

// import "./PmPage.css";

// function PmPage() {
//   const [allPMs, setAllPMs] = useState([]);
//   const [pendingPMs, setPendingPMs] = useState([]);
//   const [search, setSearch] = useState("");
//   const [editingPM, setEditingPM] = useState(null);

//   const [editData, setEditData] = useState({
//     first_name: "",
//     last_name: "",
//     email: "",
//     phone_number: "",
//   });

//   // Track field validation errors during edit
//   const [editErrors, setEditErrors] = useState({});

//   const [deleteModal, setDeleteModal] = useState(false);
//   const [selectedPM, setSelectedPM] = useState(null);
//   const [replacementType, setReplacementType] = useState("existing");
//   const [replacementPMId, setReplacementPMId] = useState("");

//   const [newPMData, setNewPMData] = useState({
//     first_name: "",
//     last_name: "",
//     email: "",
//     phone_number: "",
//   });

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const allData = await getAllPMs();
//       const pendingData = await getPendingPMs();

//       setAllPMs(allData);
//       setPendingPMs(pendingData);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   const approvedPMs = useMemo(() => {
//     return allPMs.filter(
//       (pm) =>
//         pm.is_approved &&
//         pm.is_active !== false &&
//         `${pm.first_name} ${pm.last_name}`
//           .toLowerCase()
//           .includes(search.toLowerCase())
//     );
//   }, [allPMs, search]);

//   const totalProjects = approvedPMs.reduce(
//     (acc, pm) => acc + pm.projects.length,
//     0
//   );

//   const handleApprove = async (id) => {
//     try {
//       await approvePM(id);
//       fetchData();
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   const startEdit = (pm) => {
//     setEditingPM(pm.id);
//     setEditErrors({}); // Clear any residual errors
//     setEditData({
//       first_name: pm.first_name || "",
//       last_name: pm.last_name || "",
//       email: pm.email || "",
//       phone_number: pm.phone_number || "",
//     });
//   };

//   // Helper validation function
//   const validateEditForm = () => {
//     const errors = {};
//     const nameRegex = /^[a-zA-Z\s]+$/;
//     const phoneRegex = /^[6-9]\d{9}$/;
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

//     if (!editData.first_name.trim()) {
//       errors.first_name = "First name is required.";
//     } else if (!nameRegex.test(editData.first_name)) {
//       errors.first_name = "Only alphabetic characters are allowed.";
//     } else if (editData.first_name.length < 2 || editData.first_name.length > 30) {
//       errors.first_name = "Must be between 2 and 30 characters.";
//     }

//     if (!editData.last_name.trim()) {
//       errors.last_name = "Last name is required.";
//     } else if (!nameRegex.test(editData.last_name)) {
//       errors.last_name = "Only alphabetic characters are allowed.";
//     } else if (editData.last_name.length < 2 || editData.last_name.length > 30) {
//       errors.last_name = "Must be between 2 and 30 characters.";
//     }

//     if (!editData.phone_number.trim()) {
//       errors.phone_number = "Phone number is required.";
//     } else if (!phoneRegex.test(editData.phone_number)) {
//       errors.phone_number = "Must be 10 digits starting with 6-9.";
//     }

//     if (!editData.email.trim()) {
//       errors.email = "Email is required.";
//     } else if (!emailRegex.test(editData.email)) {
//       errors.email = "Please enter a valid email address.";
//     }

//     setEditErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const saveEdit = async (id) => {
//     if (!validateEditForm()) {
//       return; 
//     }

//     try {
//       await updatePM(id, editData);
//       setEditingPM(null);
//       fetchData();
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   const handleDelete = async () => {
//     try {
//       let body = {};
//       const hasProjects = selectedPM && selectedPM.projects && selectedPM.projects.length > 0;

//       // Only pass dynamic reassignments if the PM actually holds projects
//       if (hasProjects) {
//         if (replacementType === "existing") {
//           body.new_pm_id = replacementPMId;
//         }

//         if (replacementType === "new") {
//           const createdPM = await createPM(newPMData);
//           body.new_pm_id = createdPM.user.id;
//         }
//       }

//       await deletePM(selectedPM.id, body);
//       setDeleteModal(false);
      
//       // Reset modal parameters
//       setReplacementPMId("");
//       setReplacementType("existing");
      
//       fetchData();
//     } catch (err) {
//       console.log(err);
//       if (err.error === "reassignment_required") {
//         alert(err.message);
//       }
//     }
//   };

//   return (
//     <div className="pm-page">
//       {/* HEADER */}
//       <div className="pm-header">
//         <div className="pm-title">
//           <h1>PM Management</h1>
//           <p>Manage approvals and project managers</p>
//         </div>

//         <div className="pm-search">
//           <input
//             type="text"
//             placeholder="Search PM..."
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//           />
//         </div>
//       </div>

//       {/* STATS */}
//       <div className="pm-stats">
//         <div className="pm-stat-card">
//           <div className="pm-stat-number">{allPMs.length}</div>
//           <div className="pm-stat-label">Total PMs</div>
//         </div>

//         <div className="pm-stat-card">
//           <div className="pm-stat-number">{approvedPMs.length}</div>
//           <div className="pm-stat-label">Approved PMs</div>
//         </div>

//         <div className="pm-stat-card">
//           <div className="pm-stat-number">{pendingPMs.length}</div>
//           <div className="pm-stat-label">Pending Approvals</div>
//         </div>

//         <div className="pm-stat-card">
//           <div className="pm-stat-number">{totalProjects}</div>
//           <div className="pm-stat-label">Projects Managed</div>
//         </div>
//       </div>

//       {/* PENDING */}
//       <div className="pm-section">
//         <div className="pm-section-header">
//           <div>
//             <div className="pm-section-title">Pending Approvals</div>
//             <div className="pm-section-subtitle">
//               PM requests waiting for approval
//             </div>
//           </div>
//         </div>

//         <div className="pending-list">
//           {pendingPMs.length === 0 ? (
//             <p>No pending approvals</p>
//           ) : (
//             pendingPMs.map((pm) => (
//               <div className="pending-item" key={pm.id}>
//                 <div className="pending-left">
//                   <div className="pm-avatar">{pm.first_name?.charAt(0)}</div>
//                   <div className="pm-user-info">
//                     <h4>
//                       {pm.first_name} {pm.last_name}
//                     </h4>
//                     <p>{pm.email}</p>
//                   </div>
//                 </div>

//                 <div className="pending-actions">
//                   <button
//                     className="pm-btn pm-btn-approve"
//                     onClick={() => handleApprove(pm.id)}
//                   >
//                     Approve
//                   </button>
//                 </div>
//               </div>
//             ))
//           )}
//         </div>
//       </div>

//       {/* APPROVED PMS */}
//       <div className="pm-section">
//         <div className="pm-section-header">
//           <div>
//             <div className="pm-section-title">Approved PMs</div>
//             <div className="pm-section-subtitle">Active project managers</div>
//           </div>
//         </div>

//         <div className="pm-table-wrapper">
//           <table className="pm-table">
//             <thead>
//               <tr>
//                 <th>Name</th>
//                 <th>Email</th>
//                 <th>Phone</th>
//                 <th>Status</th>
//                 <th>Projects</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>

//             <tbody>
//               {approvedPMs.map((pm) => (
//                 <tr key={pm.id}>
//                   <td>
//                     {editingPM === pm.id ? (
//                       <div style={{ display: "flex", gap: "8px", flexDirection: "column" }}>
//                         <input
//                           className={`pm-inline-input ${editErrors.first_name ? "input-error" : ""}`}
//                           value={editData.first_name}
//                           placeholder="First Name"
//                           onChange={(e) =>
//                             setEditData({ ...editData, first_name: e.target.value })
//                           }
//                         />
//                         {editErrors.first_name && (
//                           <span className="error-text" style={{ color: "red", fontSize: "11px" }}>
//                             {editErrors.first_name}
//                           </span>
//                         )}

//                         <input
//                           className={`pm-inline-input ${editErrors.last_name ? "input-error" : ""}`}
//                           value={editData.last_name}
//                           placeholder="Last Name"
//                           onChange={(e) =>
//                             setEditData({ ...editData, last_name: e.target.value })
//                           }
//                         />
//                         {editErrors.last_name && (
//                           <span className="error-text" style={{ color: "red", fontSize: "11px" }}>
//                             {editErrors.last_name}
//                           </span>
//                         )}
//                       </div>
//                     ) : (
//                       `${pm.first_name} ${pm.last_name}`
//                     )}
//                   </td>

//                   <td>
//                     {editingPM === pm.id ? (
//                       <div style={{ display: "flex", gap: "4px", flexDirection: "column" }}>
//                         <input
//                           className={`pm-inline-input ${editErrors.email ? "input-error" : ""}`}
//                           value={editData.email}
//                           onChange={(e) =>
//                             setEditData({ ...editData, email: e.target.value })
//                           }
//                         />
//                         {editErrors.email && (
//                           <span className="error-text" style={{ color: "red", fontSize: "11px" }}>
//                             {editErrors.email}
//                           </span>
//                         )}
//                       </div>
//                     ) : (
//                       pm.email
//                     )}
//                   </td>

//                   <td>
//                     {editingPM === pm.id ? (
//                       <div style={{ display: "flex", gap: "4px", flexDirection: "column" }}>
//                         <input
//                           className={`pm-inline-input ${editErrors.phone_number ? "input-error" : ""}`}
//                           value={editData.phone_number}
//                           onChange={(e) =>
//                             setEditData({ ...editData, phone_number: e.target.value })
//                           }
//                         />
//                         {editErrors.phone_number && (
//                           <span className="error-text" style={{ color: "red", fontSize: "11px" }}>
//                             {editErrors.phone_number}
//                           </span>
//                         )}
//                       </div>
//                     ) : (
//                       pm.phone_number
//                     )}
//                   </td>

//                   <td>
//                     <span className="pm-status pm-status-active">Active</span>
//                   </td>

//                   <td>
//                     <span className="pm-project-badge">
//                       {pm.projects.length} Projects
//                     </span>
//                   </td>

//                   <td>
//                     <div className="pending-actions">
//                       {editingPM === pm.id ? (
//                         <button
//                           className="pm-btn pm-btn-approve"
//                           onClick={() => saveEdit(pm.id)}
//                         >
//                           Save
//                         </button>
//                       ) : (
//                         <button
//                           className="pm-btn pm-btn-edit"
//                           onClick={() => startEdit(pm)}
//                         >
//                           Edit
//                         </button>
//                       )}

//                       <button
//                         className="pm-btn pm-btn-delete"
//                         onClick={() => {
//                           setSelectedPM(pm);
//                           setDeleteModal(true);
//                         }}
//                       >
//                         Delete
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* DELETE MODAL */}
//       {deleteModal && selectedPM && (
//         <div className="pm-modal-overlay">
//           <div className="pm-modal">
//             <h2>Delete PM</h2>
            
//             {/* Conditional Sub-views based on project counts */}
//             {selectedPM.projects && selectedPM.projects.length > 0 ? (
//               <>
//                 <p>
//                   This PM owns <strong>{selectedPM.projects.length}</strong> projects. 
//                   Reassign them before deletion.
//                 </p>

//                 <div style={{ marginTop: "20px" }}>
//                   <select
//                     className="pm-inline-input"
//                     value={replacementType}
//                     onChange={(e) => setReplacementType(e.target.value)}
//                   >
//                     <option value="existing">Select Existing PM</option>
//                     <option value="new">Create New PM</option>
//                   </select>
//                 </div>

//                 {replacementType === "existing" ? (
//                   <div style={{ marginTop: "16px" }}>
//                     <select
//                       className="pm-inline-input"
//                       value={replacementPMId}
//                       onChange={(e) => setReplacementPMId(e.target.value)}
//                     >
//                       <option value="">Choose PM</option>
//                       {approvedPMs
//                         .filter((pm) => pm.id !== selectedPM.id)
//                         .map((pm) => (
//                           <option key={pm.id} value={pm.id}>
//                             {pm.first_name} {pm.last_name}
//                           </option>
//                         ))}
//                     </select>
//                   </div>
//                 ) : (
//                   <div
//                     style={{
//                       marginTop: "16px",
//                       display: "flex",
//                       flexDirection: "column",
//                       gap: "12px",
//                     }}
//                   >
//                     <input
//                       className="pm-inline-input"
//                       placeholder="First Name"
//                       onChange={(e) =>
//                         setNewPMData({ ...newPMData, first_name: e.target.value })
//                       }
//                     />
//                     <input
//                       className="pm-inline-input"
//                       placeholder="Last Name"
//                       onChange={(e) =>
//                         setNewPMData({ ...newPMData, last_name: e.target.value })
//                       }
//                     />
//                     <input
//                       className="pm-inline-input"
//                       placeholder="Email"
//                       onChange={(e) =>
//                         setNewPMData({ ...newPMData, email: e.target.value })
//                       }
//                     />
//                     <input
//                       className="pm-inline-input"
//                       placeholder="Phone"
//                       onChange={(e) =>
//                         setNewPMData({ ...newPMData, phone_number: e.target.value })
//                       }
//                     />
//                   </div>
//                 )}
//               </>
//             ) : (
//               <p>
//                 Are you sure you want to delete <strong>{selectedPM.first_name} {selectedPM.last_name}</strong>? This action cannot be undone.
//               </p>
//             )}

//             <div className="pm-modal-actions">
//               <button className="pm-btn pm-btn-delete" onClick={handleDelete}>
//                 Confirm Delete
//               </button>
//               <button className="pm-btn" onClick={() => setDeleteModal(false)}>
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PmPage;


import React, { useEffect, useState, useMemo } from "react";
import {
  getAllPMs,
  getPendingPMs,
  approvePM,
  updatePM,
  deletePM,
  createPM
} from "../../../services/PmService";

import "./PmPage.css";
import { toast } from "react-toastify";


function PmPage() {
  const [allPMs, setAllPMs] = useState([]);
  const [pendingPMs, setPendingPMs] = useState([]);
  const [search, setSearch] = useState("");
  const [editingPM, setEditingPM] = useState(null);

  const [editData, setEditData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
  });

  // Track field validation errors during edit
  const [editErrors, setEditErrors] = useState({});

  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedPM, setSelectedPM] = useState(null);
  const [replacementType, setReplacementType] = useState("existing");
  const [replacementPMId, setReplacementPMId] = useState("");

  const [newPMData, setNewPMData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
  });

  // Track field validation errors during creation in delete modal
  const [newPMErrors, setNewPMErrors] = useState({});

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const allData = await getAllPMs();
      const pendingData = await getPendingPMs();

      setAllPMs(allData);
      setPendingPMs(pendingData);
    } catch (err) {
      console.log(err);
    }
  };

  const approvedPMs = useMemo(() => {
    return allPMs.filter(
      (pm) =>
        pm.is_approved &&
        pm.is_active !== false &&
        `${pm.first_name} ${pm.last_name}`
          .toLowerCase()
          .includes(search.toLowerCase())
    );
  }, [allPMs, search]);

  const totalProjects = approvedPMs.reduce(
    (acc, pm) => acc + pm.projects.length,
    0
  );

  const handleApprove = async (id) => {
    try {
      await approvePM(id);
      fetchData();
    } catch (err) {
      console.log(err);
    }
  };

  const startEdit = (pm) => {
    setEditingPM(pm.id);
    setEditErrors({}); 
    setEditData({
      first_name: pm.first_name || "",
      last_name: pm.last_name || "",
      email: pm.email || "",
      phone_number: pm.phone_number || "",
    });
  };

  // Prevent users from typing non-alphabetic keys in Name fields
  const handleNameKeyDown = (e) => {
    const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", " "];
    if (!/^[a-zA-Z]$/.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  // Prevent users from typing non-numeric keys in Phone field
  const handlePhoneKeyDown = (e) => {
    const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"];
    if (!/^\d$/.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  // Inline table edit validation logic
  const validateEditForm = () => {
    const errors = {};
    const nameRegex = /^[a-zA-Z\s]+$/;
    const phoneRegex = /^[6-9]\d{9}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!editData.first_name.trim()) {
      errors.first_name = "First name is required.";
    } else if (!nameRegex.test(editData.first_name)) {
      errors.first_name = "Only alphabetic characters are allowed.";
    } else if (editData.first_name.length < 2 || editData.first_name.length > 30) {
      errors.first_name = "Must be between 2 and 30 characters.";
    }

    if (!editData.last_name.trim()) {
      errors.last_name = "Last name is required.";
    } else if (!nameRegex.test(editData.last_name)) {
      errors.last_name = "Only alphabetic characters are allowed.";
    } else if (editData.last_name.length < 2 || editData.last_name.length > 30) {
      errors.last_name = "Must be between 2 and 30 characters.";
    }

    if (!editData.phone_number.trim()) {
      errors.phone_number = "Phone number is required.";
    } else if (!phoneRegex.test(editData.phone_number)) {
      errors.phone_number = "Must be 10 digits starting with 6-9.";
    }

    if (!editData.email.trim()) {
      errors.email = "Email is required.";
    } else if (!emailRegex.test(editData.email)) {
      errors.email = "Please enter a valid email address.";
    }

    setEditErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Creation form validation logic within delete modal
  const validateCreateForm = () => {
    const errors = {};
    const nameRegex = /^[a-zA-Z\s]+$/;
    const phoneRegex = /^[6-9]\d{9}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // First Name Validation
    if (!newPMData.first_name || !newPMData.first_name.trim()) {
      errors.first_name = "First name is required.";
    } else if (!nameRegex.test(newPMData.first_name)) {
      errors.first_name = "Only characters are allowed.";
    } else if (newPMData.first_name.length < 2 || newPMData.first_name.length > 30) {
      errors.first_name = "Must be between 2 and 30 characters.";
    }

    // Last Name Validation
    if (!newPMData.last_name || !newPMData.last_name.trim()) {
      errors.last_name = "Last name is required.";
    } else if (!nameRegex.test(newPMData.last_name)) {
      errors.last_name = "Only characters are allowed.";
    } else if (newPMData.last_name.length < 2 || newPMData.last_name.length > 30) {
      errors.last_name = "Must be between 2 and 30 characters.";
    }

    // Email Validation
    if (!newPMData.email || !newPMData.email.trim()) {
      errors.email = "Email is required.";
    } else if (!emailRegex.test(newPMData.email)) {
      errors.email = "Please enter a valid email address.";
    }

    // Phone Validation
    if (!newPMData.phone_number || !newPMData.phone_number.trim()) {
      errors.phone_number = "Phone number is required.";
    } else if (!phoneRegex.test(newPMData.phone_number)) {
      errors.phone_number = "Must be 10 digits starting with 6-9.";
    }

    setNewPMErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const saveEdit = async (id) => {
    if (!validateEditForm()) {
      return; 
    }

    try {
      await updatePM(id, editData);
      setEditingPM(null);
      fetchData();
    } catch (err) {
      console.log(err);
    }
  };

  const closeModalAndReset = () => {
    setDeleteModal(false);
    setReplacementPMId("");
    setReplacementType("existing");
    setNewPMErrors({});
    setNewPMData({
      first_name: "",
      last_name: "",
      email: "",
      phone_number: "",
    });
  };

  const handleDelete = async () => {
    try {
      let body = {};
      const hasProjects = selectedPM && selectedPM.projects && selectedPM.projects.length > 0;

      if (hasProjects) {
        if (replacementType === "existing") {
          if (!replacementPMId) {
            toast.error("Please choose a replacement Project Manager.");
            // alert("Please choose a replacement Project Manager.");
            return;
          }
          body.new_pm_id = replacementPMId;
        }

        if (replacementType === "new") {
          if (!validateCreateForm()) {
            return; // Errors stop execution path here and write to react state hook
          }
          const createdPM = await createPM(newPMData);
          body.new_pm_id = createdPM.user.id;
        }
      }

      await deletePM(selectedPM.id, body);
      closeModalAndReset();
      fetchData();
    } catch (err) {
      console.log(err);
      if (err.error === "reassignment_required") {
        toast.error(err.message);
      }
    }
  };

  return (
    <div className="pm-page">
      {/* HEADER */}
      <div className="pm-header">
        <div className="pm-title">
          <h1>PM Management</h1>
          <p>Manage approvals and project managers</p>
        </div>

        <div className="pm-search">
          <input
            type="text"
            placeholder="Search PM..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      {/* STATS */}
      <div className="pm-stats">
        <div className="pm-stat-card">
          <div className="pm-stat-number">{allPMs.length}</div>
          <div className="pm-stat-label">Total PMs</div>
        </div>

        <div className="pm-stat-card">
          <div className="pm-stat-number">{approvedPMs.length}</div>
          <div className="pm-stat-label">Approved PMs</div>
        </div>

        <div className="pm-stat-card">
          <div className="pm-stat-number">{pendingPMs.length}</div>
          <div className="pm-stat-label">Pending Approvals</div>
        </div>

        <div className="pm-stat-card">
          <div className="pm-stat-number">{totalProjects}</div>
          <div className="pm-stat-label">Projects Managed</div>
        </div>
      </div>

      {/* PENDING */}
      <div className="pm-section">
        <div className="pm-section-header">
          <div>
            <div className="pm-section-title">Pending Approvals</div>
            <div className="pm-section-subtitle">
              PM requests waiting for approval
            </div>
          </div>
        </div>

        <div className="pending-list">
          {pendingPMs.length === 0 ? (
            <p>No pending approvals</p>
          ) : (
            pendingPMs.map((pm) => (
              <div className="pending-item" key={pm.id}>
                <div className="pending-left">
                  <div className="pm-avatar">{pm.first_name?.charAt(0)}</div>
                  <div className="pm-user-info">
                    <h4>
                      {pm.first_name} {pm.last_name}
                    </h4>
                    <p>{pm.email}</p>
                  </div>
                </div>

                <div className="pending-actions">
                  <button
                    className="pm-btn pm-btn-approve"
                    onClick={() => handleApprove(pm.id)}
                  >
                    Approve
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      {/* APPROVED PMS */}
      <div className="pm-section">
        <div className="pm-section-header">
          <div>
            <div className="pm-section-title">Approved PMs</div>
            <div className="pm-section-subtitle">Active project managers</div>
          </div>
        </div>

        <div className="pm-table-wrapper">
          <table className="pm-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Status</th>
                <th>Projects</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {approvedPMs.map((pm) => (
                <tr key={pm.id}>
                  <td>
                    {editingPM === pm.id ? (
                      <div style={{ display: "flex", gap: "8px", flexDirection: "column" }}>
                        <input
                          className={`pm-inline-input ${editErrors.first_name ? "input-error" : ""}`}
                          value={editData.first_name}
                          placeholder="First Name"
                          onKeyDown={handleNameKeyDown}
                          onChange={(e) =>
                            setEditData({ ...editData, first_name: e.target.value })
                          }
                        />
                        {editErrors.first_name && (
                          <span className="error-text" style={{ color: "red", fontSize: "11px" }}>
                            {editErrors.first_name}
                          </span>
                        )}

                        <input
                          className={`pm-inline-input ${editErrors.last_name ? "input-error" : ""}`}
                          value={editData.last_name}
                          placeholder="Last Name"
                          onKeyDown={handleNameKeyDown}
                          onChange={(e) =>
                            setEditData({ ...editData, last_name: e.target.value })
                          }
                        />
                        {editErrors.last_name && (
                          <span className="error-text" style={{ color: "red", fontSize: "11px" }}>
                            {editErrors.last_name}
                          </span>
                        )}
                      </div>
                    ) : (
                      `${pm.first_name} ${pm.last_name}`
                    )}
                  </td>

                  <td>
                    {editingPM === pm.id ? (
                      <div style={{ display: "flex", gap: "4px", flexDirection: "column" }}>
                        <input
                          className={`pm-inline-input ${editErrors.email ? "input-error" : ""}`}
                          value={editData.email}
                          onChange={(e) =>
                            setEditData({ ...editData, email: e.target.value })
                          }
                        />
                        {editErrors.email && (
                          <span className="error-text" style={{ color: "red", fontSize: "11px" }}>
                            {editErrors.email}
                          </span>
                        )}
                      </div>
                    ) : (
                      pm.email
                    )}
                  </td>

                  <td>
                    {editingPM === pm.id ? (
                      <div style={{ display: "flex", gap: "4px", flexDirection: "column" }}>
                        <input
                          className={`pm-inline-input ${editErrors.phone_number ? "input-error" : ""}`}
                          value={editData.phone_number}
                          onKeyDown={handlePhoneKeyDown}
                          maxLength={10}
                          onChange={(e) =>
                            setEditData({ ...editData, phone_number: e.target.value })
                          }
                        />
                        {editErrors.phone_number && (
                          <span className="error-text" style={{ color: "red", fontSize: "11px" }}>
                            {editErrors.phone_number}
                          </span>
                        )}
                      </div>
                    ) : (
                      pm.phone_number
                    )}
                  </td>

                  <td>
                    <span className="pm-status pm-status-active">Active</span>
                  </td>

                  <td>
                    <span className="pm-project-badge">
                      {pm.projects.length} Projects
                    </span>
                  </td>

                  <td>
                    <div className="pending-actions">
                      {editingPM === pm.id ? (
                        <button
                          className="pm-btn pm-btn-approve"
                          onClick={() => saveEdit(pm.id)}
                        >
                          Save
                        </button>
                      ) : (
                        <button
                          className="pm-btn pm-btn-edit"
                          onClick={() => startEdit(pm)}
                        >
                          Edit
                        </button>
                      )}

                      <button
                        className="pm-btn pm-btn-delete"
                        onClick={() => {
                          setSelectedPM(pm);
                          setDeleteModal(true);
                        }}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

{/* DELETE MODAL */}
      {deleteModal && selectedPM && (
        <div className="pm-modal-overlay">
          <div 
            className="pm-modal" 
            style={{ 
              height: "auto", 
              width: "100%",
              maxWidth: "450px", 
              padding: "24px",
              boxSizing: "border-box",
              display: "flex", 
              flexDirection: "column",
              gap: "16px"
            }}
          >
            <h2 style={{ margin: 0 }}>Delete PM</h2>
            
            {selectedPM.projects && selectedPM.projects.length > 0 ? (
              <>
                <p style={{ margin: 0 }}>
                  This PM owns <strong>{selectedPM.projects.length}</strong> projects. 
                  Reassign them before deletion.
                </p>

                <div>
                  <select
                    className="pm-inline-input"
                    value={replacementType}
                    onChange={(e) => {
                      setReplacementType(e.target.value);
                      setNewPMErrors({}); 
                    }}
                  >
                    <option value="existing">Select Existing PM</option>
                    <option value="new">Create New PM</option>
                  </select>
                </div>

                {replacementType === "existing" ? (
                  <div>
                    <select
                      className="pm-inline-input"
                      value={replacementPMId}
                      onChange={(e) => setReplacementPMId(e.target.value)}
                    >
                      <option value="">Choose PM</option>
                      {approvedPMs
                        .filter((pm) => pm.id !== selectedPM.id)
                        .map((pm) => (
                          <option key={pm.id} value={pm.id}>
                            {pm.first_name} {pm.last_name}
                          </option>
                        ))}
                    </select>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "14px",
                    }}
                  >
                    {/* First Name */}
                    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                      <input
                        style={{ border: newPMErrors.first_name ? "1px solid red" : "", width: "100%" }}
                        className="pm-inline-input"
                        placeholder="First Name"
                        value={newPMData.first_name}
                        onKeyDown={handleNameKeyDown}
                        onChange={(e) => {
                          setNewPMData({ ...newPMData, first_name: e.target.value });
                          if(newPMErrors.first_name) setNewPMErrors({...newPMErrors, first_name: ""});
                        }}
                      />
                      {newPMErrors.first_name && (
                        <span style={{ color: "red", fontSize: "12px", display: "block", marginTop: "4px", textAlign: "left", fontWeight: "500" }}>
                          {newPMErrors.first_name}
                        </span>
                      )}
                    </div>

                    {/* Last Name */}
                    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                      <input
                        style={{ border: newPMErrors.last_name ? "1px solid red" : "", width: "100%" }}
                        className="pm-inline-input"
                        placeholder="Last Name"
                        value={newPMData.last_name}
                        onKeyDown={handleNameKeyDown}
                        onChange={(e) => {
                          setNewPMData({ ...newPMData, last_name: e.target.value });
                          if(newPMErrors.last_name) setNewPMErrors({...newPMErrors, last_name: ""});
                        }}
                      />
                      {newPMErrors.last_name && (
                        <span style={{ color: "red", fontSize: "12px", display: "block", marginTop: "4px", textAlign: "left", fontWeight: "500" }}>
                          {newPMErrors.last_name}
                        </span>
                      )}
                    </div>

                    {/* Email */}
                    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                      <input
                        style={{ border: newPMErrors.email ? "1px solid red" : "", width: "100%" }}
                        className="pm-inline-input"
                        placeholder="Email"
                        value={newPMData.email}
                        onChange={(e) => {
                          setNewPMData({ ...newPMData, email: e.target.value });
                          if(newPMErrors.email) setNewPMErrors({...newPMErrors, email: ""});
                        }}
                      />
                      {newPMErrors.email && (
                        <span style={{ color: "red", fontSize: "12px", display: "block", marginTop: "4px", textAlign: "left", fontWeight: "500" }}>
                          {newPMErrors.email}
                        </span>
                      )}
                    </div>

                    {/* Phone */}
                    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                      <input
                        style={{ border: newPMErrors.phone_number ? "1px solid red" : "", width: "100%" }}
                        className="pm-inline-input"
                        placeholder="Phone"
                        value={newPMData.phone_number}
                        onKeyDown={handlePhoneKeyDown}
                        maxLength={10}
                        onChange={(e) => {
                          setNewPMData({ ...newPMData, phone_number: e.target.value });
                          if(newPMErrors.phone_number) setNewPMErrors({...newPMErrors, phone_number: ""});
                        }}
                      />
                      {newPMErrors.phone_number && (
                        <span style={{ color: "red", fontSize: "12px", display: "block", marginTop: "4px", textAlign: "left", fontWeight: "500" }}>
                          {newPMErrors.phone_number}
                        </span>
                      )}
                    </div>
                  </div>
                )}
              </>
            ) : (
              <p style={{ margin: 0, lineHeight: "1.5" }}>
                Are you sure you want to delete <strong>{selectedPM.first_name} {selectedPM.last_name}</strong>? This action cannot be undone.
              </p>
            )}

            <div 
              className="pm-modal-actions" 
              style={{ 
                display: "flex", 
                gap: "12px", 
                justifyContent: "flex-end", 
                marginTop: "8px" 
              }}
            >
              <button className="pm-btn pm-btn-delete" onClick={handleDelete}>
                Confirm Delete
              </button>
              <button className="pm-btn" onClick={closeModalAndReset}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PmPage;